import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { UserPlus } from "lucide-react";
import { motion } from "framer-motion";

const RegisterButton = ({ className = "" }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = location.pathname === "/register";

  return (
    <div className="relative h-20 flex items-center justify-center">
      <button
        onClick={() => navigate("/register")}
        className={`group relative flex items-center justify-center px-6 py-2.5 bg-[#FBBF24] hover:bg-[#F59E0B] text-[#004A8D] font-black text-xs uppercase tracking-widest rounded-xl transition-all duration-300 shadow-md hover:shadow-lg active:scale-95 ${className}`}
      >
        <UserPlus size={16} className="mr-2 lg:hidden xl:block" />
        REGISTRATION
      </button>
      {isActive && (
        <motion.div 
          layoutId="navbar-underline" 
          className="absolute bottom-[-4px] left-4 right-4 h-[3px] bg-[#044A8C] z-[60]" 
          transition={{ type: "spring", stiffness: 380, damping: 30 }} 
        />
      )}
    </div>
  );
};

export default RegisterButton;